/**
 * The path of the HTML sitemap page.
 *
 * Kept apart from `constants/html-sitemap.ts`, which imports every content
 * registry, so the route table and the components that only need the link
 * (`LearningHubLinks`, the 404 page) do not pull the whole site's copy into
 * their bundles.
 */
export const HTML_SITEMAP_PATH = '/sitemap';
